<!-- 人员活跃时段统计 -->
<template>
  <div class="active-person">
    <div class="search search-container" v-if="more">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('nameOfFence')">
          <el-input v-model="formInline.fenceName" clearable :placeholder="$t('nameOfFence')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('Recordtime')">
          <el-date-picker
            v-model="formInline.startTime"
            :placeholder="$t('startDate')"
            type="date"
            value-format="yyyy-MM-dd"
            popper-class="date-picker-blue-hw"
            :clearable="true"
            @input="clearTime"
            @clear="clearTime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="gettaskDayCount" class="serachBtn">{{ $t('query') }}</el-button>
          <el-button type="primary" @click="exportStatic" class="serachBtn">{{ $t('exportData') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :id="more ? 'moreStaticChart' : isHome ? 'moreStaticChart' : 'popuChart'" :style="{ width: '100%' }"></div>
    <div class="pagination" v-if="more && xData.length >= 16">
      <span>{{ staticProport.currentPage }}/{{ staticProport.totalData }}</span>
      <el-pagination
        layout="prev,next"
        @current-change="handleStaticChange"
        :current-page="staticProport.currentPage"
        :page-size="staticProport.pageSize"
        :total="staticProport.totalUser"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { geoFencesStatistics, getExportStatisticse } from '@/api/new-person/newPerson'
import { downloadBlobExcel, splitArray } from '@/util/common'
import { mapGetters } from 'vuex'
export default {
  props: {
    currenNode: {
      type: Object,
    },
    more: {
      type: Boolean,
    },
    StaticSearchTime: {
      type: String,
    },
    isHome: {
      type: Boolean,
    },
  },
  data() {
    return {
      formInline: {
        startTime: this.StaticSearchTime,
      },
      lightbg: '',
      // 图标颜色数组
      echartInfo: {
        lineChart: '',
        colorStops: '',
        colorGra: '',
        colorOffset: '',
      },
      // 到岗人数
      employeesDutyData: [],
      // 缺勤人数
      unfinishData: [],
      // x轴数据
      xData: [],
      // 显示查看更多按钮
      showMoreBtn: false,
      allData: { reportDuty: [], lackPosition: [], users: [] },
      staticProport: {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 16,
        XuserData: [],
        onlineData: [],
        offlineData: [],
      },
    }
  },
  mounted() {
    this.gettaskDayCount()
  },
  methods: {
    // 轨迹统计分页
    handleStaticChange(val) {
      this.staticProport.currentPage = val
      this.allData.reportDuty = this.staticProport.onlineData[val - 1]
      this.allData.lackPosition = this.staticProport.offlineData[val - 1]
      this.allData.users = this.staticProport.XuserData[val - 1]
      this.drawMorePeriodChart()
    },
    // 做数据截取
    arrayChunk() {
      // 页数向上取整
      let proportPage = Math.ceil(this.employeesDutyData.length / 16)
      // 总页数
      this.staticProport.totalUser = this.employeesDutyData.length
      this.staticProport.totalData = proportPage

      this.staticProport.onlineData = splitArray(this.employeesDutyData, 16)
      this.staticProport.offlineData = splitArray(this.unfinishData, 16)
      this.staticProport.XuserData = splitArray(this.xData, 16)
      // 第一页数据
      this.allData.reportDuty = this.staticProport.onlineData[0]
      this.allData.lackPosition = this.staticProport.offlineData[0]
      this.allData.users = this.staticProport.XuserData[0]
      this.drawMorePeriodChart()
    },
    clearTime(val) {
      if (!val) {
        this.formInline.startTime = ''
      }
    },
    // 导出
    exportStatic() {
      let params = {
        ouId: this.currenNode.id,
        logTimestamp: this.more ? this.formInline.startTime + ' 00:00:00' : this.StaticSearchTime + ' 00:00:00',
        name: this.formInline.fenceName,
      }
      getExportStatisticse(params).then(res => {
        downloadBlobExcel(res, this.$t('attendanceStatisticsTable') + '.xls')
      })
    },
    // 人员考勤统计
    gettaskDayCount() {
      let time = ''
      if (this.more && this.formInline.startTime) {
        time = this.formInline.startTime + ' 00:00:00'
      } else if (!this.more && this.StaticSearchTime) {
        time = this.StaticSearchTime + ' 00:00:00'
      } else {
        time = this.StaticSearchTime + ' 00:00:00'
      }
      let param = {
        ouId: this.currenNode.id,
        logTimestamp: time,
        name: this.formInline.fenceName,
      }
      this.employeesDutyData = []
      this.unfinishData = []
      this.xData = []
      this.showMoreBtn = false

      geoFencesStatistics(param).then(res => {
        if (res.state === 0) {
          if (res.data) {
            res.data.map(item => {
              // 到岗人数
              this.employeesDutyData.push(item.report)
              // 缺勤人数
              this.unfinishData.push(item.absence)
              this.xData.push(item.name)
            })
            setTimeout(() => {
              if (!this.more && !this.isHome) {
                this.drawPeriodChart()
                if (this.xData.length >= 11) {
                  this.showMoreBtn = true
                  // 到岗人数
                  this.employeesDutyData = this.employeesDutyData.slice(0, 11)
                  // 缺勤人数
                  this.unfinishData = this.unfinishData.slice(0, 11)
                  this.xData = this.xData.slice(0, 11)
                }
              } else if (this.isHome && !this.more) {
                // 首页显示数据处理
                if (this.xData.length >= 5) {
                  this.showMoreBtn = true
                  // 到岗人数
                  this.allData.reportDuty = this.employeesDutyData.slice(0, 5)
                  // 缺勤人数
                  this.allData.lackPosition = this.unfinishData.slice(0, 5)
                  this.allData.users = this.xData.slice(0, 5)
                } else {
                  this.allData.reportDuty = this.employeesDutyData
                  this.allData.lackPosition = this.unfinishData
                  this.allData.users = this.xData
                }
                this.drawMorePeriodChart()
              } else {
                if (this.more && this.xData.length >= 16) {
                  this.arrayChunk()
                } else {
                  this.allData.reportDuty = this.employeesDutyData
                  this.allData.lackPosition = this.unfinishData
                  this.allData.users = this.xData
                  this.drawMorePeriodChart()
                }
              }

              this.$emit('showMoreStatic', this.showMoreBtn)
            }, 500)
          }
        }
      })
    },
    // 考勤统计柱状图
    drawPeriodChart() {
      // 初始化echart
      this.$nextTick(() => {
        this.myEchartLine = this.$echarts.init(document.getElementById('popuChart'))
        let colorOne = new this.$echarts.graphic.LinearGradient(
          0,
          0,
          1,
          0,
          [
            {
              offset: 0,
              color: 'rgba(0, 110, 255, 1)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(5, 242, 253, 1)', // 100% 处的颜色
            },
          ],
          false
        )
        let colorthree = new this.$echarts.graphic.LinearGradient(
          0,
          0,
          1,
          0,

          [
            {
              offset: 0,
              color: 'rgba(250, 104, 40, 1)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(254, 179, 17, 1)', // 100% 处的颜色
            },
          ],
          false
        )
        // 绘制图表
        this.myEchartLine.setOption({
          legend: {
            textStyle: {
              color: this.lightbg,
            },
          },
          color: [colorOne, colorthree],
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echartInfo.lineChart,
              },
            },
          },
          yAxis: {
            type: 'category',
            data: this.xData,
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
            axisLine: {
              lineStyle: {
                color: 'rbga(20, 53, 139, 0.5)', //更改坐标轴颜色
              },
            },
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            x: '3%', //距离左边
            x2: '3%', //距离右边
            y: '10%', // 上距离
            y2: '5%', // 下距离
            containLabel: true,
          },
          series: [
            {
              type: 'bar',
              name: this.$t('reportToDuty'),
              data: this.employeesDutyData,
              barGap: '20%',
              barWidth: 10,
              itemStyle: {
                color: function() {
                  return colorOne
                },
              },
            },
            {
              type: 'bar',
              name: this.$t('absence'),
              data: this.unfinishData,
              barGap: '20%',
              barWidth: 10,
              itemStyle: {
                color: function() {
                  return colorthree
                },
              },
            },
          ],
        })
      })
    },
    // 更多查看- 考勤统计柱状图
    drawMorePeriodChart() {
      // 初始化echart
      this.$nextTick(() => {
        this.myEchartLine = this.$echarts.init(document.getElementById('moreStaticChart'))
        let colorOne = new this.$echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(0, 110, 255, 1)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(5, 242, 253, 1)', // 100% 处的颜色
            },
          ],
          false
        )
        let colorthree = new this.$echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,

          [
            {
              offset: 0,
              color: 'rgba(250, 104, 40, 1)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(254, 179, 17, 1)', // 100% 处的颜色
            },
          ],
          false
        )
        // 绘制图表
        this.myEchartLine.setOption({
          legend: {
            textStyle: {
              color: this.lightbg,
            },
          },
          color: [colorOne, colorthree],
          xAxis: {
            type: 'category',
            data: this.allData.users,
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 14, //更改坐标轴文字大小
              },
            },
            axisLine: {
              lineStyle: {
                color: 'rbga(20, 53, 139, 0.5)', //更改坐标轴颜色
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echartInfo.lineChart,
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 14, //更改坐标轴文字大小
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echartInfo.lineChart,
              },
            },
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            x: '3%', //距离左边
            x2: '3%', //距离右边
            y: '10%', // 上距离
            y2: '5%', // 下距离
            containLabel: true,
          },
          series: [
            {
              type: 'bar',
              name: this.$t('reportToDuty'),
              data: this.allData.reportDuty,
              barGap: '20%',
              barWidth: 10,
              itemStyle: {
                color: function() {
                  return colorOne
                },
              },
            },
            {
              type: 'bar',
              name: this.$t('absence'),
              data: this.allData.lackPosition,
              barGap: '20%',
              barWidth: 10,
              itemStyle: {
                color: function() {
                  return colorthree
                },
              },
            },
          ],
        })
      })
    },
    // 切换主题 图标的颜色要重新刷新
    getChartColor() {
      if (this.isDefaultTheme) {
        this.lightbg = '#333'
        this.echartInfo.lineChart = 'rgba(232, 236, 243, 1)'
      } else {
        this.lightbg = '#fff'
        this.echartInfo.lineChart = 'rgba(20, 53, 139, 0.7)'
      }
      if (!this.more && !this.isHome) {
        this.drawPeriodChart()
      } else {
        this.drawMorePeriodChart()
      }
    },
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler() {
        this.getChartColor()
      },
    },
    StaticSearchTime: {
      immediate: true,
      handler(val) {
        if (val && !this.more && this.formInline.startTime !== val) {
          this.gettaskDayCount()
          this.formInline.startTime = val
        }
      },
    },
    'currenNode.id': {
      immediate: true,
      handler(val) {
        if (this.currenNode.id !== val) {
          this.gettaskDayCount()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.active-person
  height calc(100% - 60px)
  position: relative
  margin-top: 10px
  .pagination
    position absolute
    top 8%
    right 34%
    display flex
    span
      height: 30px;/*no*/
      line-height: 30px;/*no*/
      color #333
  #popuChart
    height 100%
  #moreStaticChart
    height 98%
  .search
    margin-left: 40px
    margin-right: 50px
    >>>.el-input__inner
      height: 36px;/*no*/
      line-height: 36px;/*no*/
.unit_icon
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  margin-right 5px
  background: rgb(254, 40, 136)
</style>
